/* global wp */
import { ConditionalControl } from './conditional/control.js';
import { ConditionalSelectControl } from './conditional-select/control.js';
import { ConditionalHeadingControl } from './conditional-heading/control.js';

wp.customize.controlConstructor.kadence_conditional_control = ConditionalControl;
wp.customize.controlConstructor.kadence_conditional_select_control = ConditionalSelectControl;
wp.customize.controlConstructor.kadence_conditional_heading_control = ConditionalHeadingControl;